import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "customTextField";

export const classes = {
  hideArrows: `${PREFIX}-hideArrows`,
};

export const CustomTextField = styled(TextField)({
  [`&.${classes.hideArrows}`]: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
});
